import React from "react";

import InviteCards from "js/components/invites";
import initJQuery from "lib/vendor/jquery";

export default class ApplicationSummaryInvites extends React.PureComponent {
    componentDidMount() {
        initJQuery();

        new InviteCards({
            el: this.container,
        }).render();
    }

    render() {
        return <div className="app-summary__invites" ref={(c) => (this.container = c)} />;
    }
}
